import { AbstractControl, Validators } from '@angular/forms';

type RsModelYearValidatorError = {
  modelYear: { value: string, valid: false, msg?: string }
} | null;

declare module '@angular/forms' {
  export namespace Validators {
    let rsModelYearValidator: (control: AbstractControl) => RsModelYearValidatorError;
  }
}

Validators.rsModelYearValidator = (control: AbstractControl<string>): RsModelYearValidatorError => {
  return control.rsHasValue() ? validateModelYear(control) : null;
}

function validateModelYear(control: AbstractControl<string>): RsModelYearValidatorError {
  const patternValidator = Validators.pattern(/^(19|20)\d{2}$/);
  const patternError = patternValidator(control);
  if (patternError) {
    return {
      modelYear: {
        value: control.value,
        valid: false,
        msg: 'Invalid model year'
      }
    };
  }
  return null;
}
